import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { Backdrop, Fade, Modal } from "@material-ui/core";
import FormInput from "../form-input/form-input.component";
import VerifyNumberContainer from "../verify-number/verify-number-container";
import Loader from "../loader/loader.component";
import { useAccountPersonalInfo } from "./useAccountPersonalInfo";
import { phoneInputStyle, useStyles } from "./account-personal-info.styles";

// The published type declarations for this library omit some supported
// props (e.g. `withCountryCallingCode`) and type `value`/`onChange` as
// `E164Number` instead of `string`.
const PhoneInputAny = PhoneInput as unknown as React.ComponentType<any>;
const VerifyNumberContainerAny = VerifyNumberContainer as unknown as React.ComponentType<any>;

const AccountPersonalInfo: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const {
    loading,
    phoneValue,
    setPhoneValue,
    fullnameValue,
    onFullnameChange,
    onEditPhone,
    isPhoneEditable,
    isVerifyModalOpen,
    closeVerifyModal,
  } = useAccountPersonalInfo();

  if (loading) return <Loader color={"#B73232"} size={50} />;

  return (
    <div className={classes.container}>
      <span className={classes.title}>{t("account.Personal Info")}</span>

      <div className={classes.nameRow}>
        <FormInput
          name="fullnameValue"
          type="string"
          value={fullnameValue}
          handleChange={onFullnameChange}
          label={t("checkout.yourFullName")}
          border={"1px solid rgba(0, 0, 0, 0.1)"}
          maxWidth={"360"}
          margin={"0px 0px 36px 0px"}
          style={{ width: 360 }}
        />
      </div>

      <span className={classes.phoneTitle}>{t("account.Phone Number")}</span>

      <div className={classes.phoneRow}>
        <PhoneInputAny
          style={phoneInputStyle}
          defaultCountry="IL"
          withCountryCallingCode
          international
          placeholder={t("checkout.enterPhoneNumber")}
          value={phoneValue}
          onChange={(value: string | undefined) => setPhoneValue(value ?? "")}
        />
        <span
          className={clsx(classes.actionLink, {
            [classes.actionLinkActive]: isPhoneEditable,
          })}
          onClick={onEditPhone}
        >
          {t("verifyNumber.verify")}
        </span>
      </div>

      <Modal
        className={classes.modal}
        open={isVerifyModalOpen}
        onClose={closeVerifyModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={isVerifyModalOpen}>
          <VerifyNumberContainerAny
            handleClose={closeVerifyModal}
            phoneNumber={phoneValue}
            setPhoneValue={setPhoneValue}
            setOpen={closeVerifyModal}
          />
        </Fade>
      </Modal>
    </div>
  );
};

export default AccountPersonalInfo;
